import { useState, useEffect } from 'react';

/**
 * Returns true when viewport width is ≤ 768px.
 * Reacts to window resize events.
 */
export default function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= breakpoint);

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${breakpoint}px)`);
    const handler = e => setIsMobile(e.matches);
    // Modern API
    if (mq.addEventListener) mq.addEventListener('change', handler);
    else mq.addListener(handler); // Safari <14 fallback
    return () => {
      if (mq.removeEventListener) mq.removeEventListener('change', handler);
      else mq.removeListener(handler);
    };
  }, [breakpoint]);

  return isMobile;
}
